/* eslint-disable */
import generateStoreSetters from '@/helpers/generateStoreSetters';
import { State, StateResults } from './state';

const state = new State();

const store = {
  namespaced: true,
  state,
  mutations: {
    ...generateStoreSetters(state),
    clearState: (stateResults: StateResults): void => {}
  },
  actions: {},
  modules: {},
  getters: {}
};

export { store as results };
